export const requestLogin = ({ wixCodeApi })=>{
    return async (lang)=>{
        return wixCodeApi.user.promptLogin({
            lang
        }).catch(()=>{});
    };
};
export const requestLogout = ({ wixCodeApi })=>{
    return async ()=>{
        return wixCodeApi.user.logout();
    };
};

//# sourceMappingURL=user-actions.js.map